import React, { useState, useEffect } from 'react';
import './Dashboard.css';
import { dashboardService } from '../services/dashboardService';

const Dashboard = ({ onNavigateToClientes, onNavigateToFinanceiro }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadDashboard();
  }, []);

  const loadDashboard = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await dashboardService.getDashboardData();
      if (response.success) {
        setData(response.data);
      }
    } catch (err) {
      setError('Erro ao carregar dashboard');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">⏳ Carregando dashboard...</div>;
  if (error) return <div className="error">❌ {error}</div>;
  if (!data) return null;

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h2>📊 Dashboard Geral</h2>
        <div className="dashboard-actions">
          <button className="btn-navigate" onClick={onNavigateToClientes}>
            📋 Ver Lista de Clientes
          </button>
          <button className="btn-navigate btn-financeiro" onClick={onNavigateToFinanceiro}>
            💰 Gestão Financeira
          </button>
        </div>
      </div>

      {/* Visão Geral */}
      <div className="dashboard-section">
        <h3 className="section-title">🌐 Visão Geral</h3>
        <div className="stats-grid">
          <div className="stat-box stat-large">
            <div className="stat-icon">📊</div>
            <div className="stat-content">
              <span className="stat-label">Total de Clientes</span>
              <span className="stat-value">{data.geral.total}</span>
            </div>
          </div>
          
          <div className="stat-box stat-success">
            <div className="stat-icon">✅</div>
            <div className="stat-content">
              <span className="stat-label">Ativos</span>
              <span className="stat-value">{data.geral.ativos}</span>
              <span className="stat-percent">{data.percentuais.ativosPct}%</span>
            </div>
          </div>

          <div className="stat-box stat-courtesy">
            <div className="stat-icon">🎁</div>
            <div className="stat-content">
              <span className="stat-label">Cortesia</span>
              <span className="stat-value">{data.geral.cortesias}</span>
              <span className="stat-percent">{data.percentuais.cortesiasPct}%</span>
            </div>
          </div>

          <div className="stat-box stat-warning">
            <div className="stat-icon">⚠️</div>
            <div className="stat-content">
              <span className="stat-label">Inadimplência</span>
              <span className="stat-value">{data.geral.inadimplentes}</span>
              <span className="stat-percent">{data.percentuais.inadimplentesPct}%</span>
            </div>
          </div>

          <div className="stat-box stat-info">
            <div className="stat-icon">🔧</div>
            <div className="stat-content">
              <span className="stat-label">A Instalar</span>
              <span className="stat-value">{data.geral.aInstalar}</span>
              <span className="stat-percent">{data.percentuais.aInstalarPct}%</span>
            </div>
          </div>

          <div className="stat-box stat-danger">
            <div className="stat-icon">❌</div>
            <div className="stat-content">
              <span className="stat-label">Cancelados</span>
              <span className="stat-value">{data.geral.cancelados}</span>
              <span className="stat-percent">{data.percentuais.canceladosPct}%</span>
            </div>
          </div>
        </div>
      </div>

      {/* Por Localidade */}
      <div className="dashboard-section">
        <h3 className="section-title">📍 Por Localidade</h3>
        <div className="location-grid">
          
          {/* Vila Isabel */}
          <div className="location-card">
            <div className="location-header">
              <h4>📍 Vila Isabel</h4>
              <div className="location-total">{data.vilaIsabel.total} clientes</div>
              <div className="location-percent">{data.percentuais.vilaIsabelPct}% do total</div>
            </div>
            <div className="location-stats">
              <div className="location-stat">
                <span className="dot dot-success"></span>
                <span className="label">Ativos:</span>
                <span className="value">{data.vilaIsabel.ativos}</span>
              </div>
              <div className="location-stat">
                <span className="dot dot-courtesy"></span>
                <span className="label">Cortesia:</span>
                <span className="value">{data.vilaIsabel.cortesias}</span>
              </div>
              <div className="location-stat">
                <span className="dot dot-warning"></span>
                <span className="label">Inadimplência:</span>
                <span className="value">{data.vilaIsabel.inadimplentes}</span>
              </div>
              <div className="location-stat">
                <span className="dot dot-info"></span>
                <span className="label">A Instalar:</span>
                <span className="value">{data.vilaIsabel.aInstalar}</span>
              </div>
              <div className="location-stat">
                <span className="dot dot-danger"></span>
                <span className="label">Cancelados:</span>
                <span className="value">{data.vilaIsabel.cancelados}</span>
              </div>
            </div>
            <button 
              className="location-btn"
              onClick={() => onNavigateToClientes('vila-isabel')}
            >
              Ver Clientes de Vila Isabel →
            </button>
          </div>

          {/* Nilópolis */}
          <div className="location-card">
            <div className="location-header">
              <h4>📍 Nilópolis</h4>
              <div className="location-total">{data.nilopolis.total} clientes</div>
              <div className="location-percent">{data.percentuais.nilopolisPct}% do total</div>
            </div>
            <div className="location-stats">
              <div className="location-stat">
                <span className="dot dot-success"></span>
                <span className="label">Ativos:</span>
                <span className="value">{data.nilopolis.ativos}</span>
              </div>
              <div className="location-stat">
                <span className="dot dot-courtesy"></span>
                <span className="label">Cortesia:</span>
                <span className="value">{data.nilopolis.cortesias}</span>
              </div>
              <div className="location-stat">
                <span className="dot dot-warning"></span>
                <span className="label">Inadimplência:</span>
                <span className="value">{data.nilopolis.inadimplentes}</span>
              </div>
              <div className="location-stat">
                <span className="dot dot-info"></span>
                <span className="label">A Instalar:</span>
                <span className="value">{data.nilopolis.aInstalar}</span>
              </div>
              <div className="location-stat">
                <span className="dot dot-danger"></span>
                <span className="label">Cancelados:</span>
                <span className="value">{data.nilopolis.cancelados}</span>
              </div>
            </div>
            <button 
              className="location-btn"
              onClick={() => onNavigateToClientes('nilopolis')}
            >
              Ver Clientes de Nilópolis →
            </button>
          </div>
        </div>
      </div>

      {/* Distribuição Visual */}
      <div className="dashboard-section">
        <h3 className="section-title">📈 Distribuição de Status</h3>
        <div className="chart-container">
          <div className="progress-bars">
            <div className="progress-item">
              <div className="progress-header">
                <span className="progress-label">✅ Ativos</span>
                <span className="progress-value">{data.geral.ativos} ({data.percentuais.ativosPct}%)</span>
              </div>
              <div className="progress-bar">
                <div 
                  className="progress-fill progress-success" 
                  style={{width: `${data.percentuais.ativosPct}%`}}
                ></div>
              </div>
            </div>

            <div className="progress-item">
              <div className="progress-header">
                <span className="progress-label">🎁 Cortesia</span>
                <span className="progress-value">{data.geral.cortesias} ({data.percentuais.cortesiasPct}%)</span>
              </div>
              <div className="progress-bar">
                <div 
                  className="progress-fill progress-courtesy" 
                  style={{width: `${data.percentuais.cortesiasPct}%`}}
                ></div>
              </div>
            </div>

            <div className="progress-item">
              <div className="progress-header">
                <span className="progress-label">⚠️ Inadimplência</span>
                <span className="progress-value">{data.geral.inadimplentes} ({data.percentuais.inadimplentesPct}%)</span>
              </div>
              <div className="progress-bar">
                <div 
                  className="progress-fill progress-warning" 
                  style={{width: `${data.percentuais.inadimplentesPct}%`}}
                ></div>
              </div>
            </div>

            <div className="progress-item">
              <div className="progress-header">
                <span className="progress-label">🔧 A Instalar</span>
                <span className="progress-value">{data.geral.aInstalar} ({data.percentuais.aInstalarPct}%)</span>
              </div>
              <div className="progress-bar">
                <div 
                  className="progress-fill progress-info" 
                  style={{width: `${data.percentuais.aInstalarPct}%`}}
                ></div>
              </div>
            </div>

            <div className="progress-item">
              <div className="progress-header">
                <span className="progress-label">❌ Cancelados</span>
                <span className="progress-value">{data.geral.cancelados} ({data.percentuais.canceladosPct}%)</span>
              </div>
              <div className="progress-bar">
                <div 
                  className="progress-fill progress-danger" 
                  style={{width: `${data.percentuais.canceladosPct}%`}}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Comparativo por Localidade */}
      <div className="dashboard-section">
        <h3 className="section-title">🗺️ Distribuição Geográfica</h3>
        <div className="comparison-grid">
          <div className="comparison-card">
            <div className="comparison-bar">
              <div 
                className="comparison-fill comparison-vila" 
                style={{height: `${data.percentuais.vilaIsabelPct}%`}}
              >
                <span className="comparison-label">{data.percentuais.vilaIsabelPct}%</span>
              </div>
            </div>
            <div className="comparison-title">Vila Isabel</div>
            <div className="comparison-value">{data.vilaIsabel.total} clientes</div>
          </div>

          <div className="comparison-card">
            <div className="comparison-bar">
              <div 
                className="comparison-fill comparison-nilopolis" 
                style={{height: `${data.percentuais.nilopolisPct}%`}}
              >
                <span className="comparison-label">{data.percentuais.nilopolisPct}%</span>
              </div>
            </div>
            <div className="comparison-title">Nilópolis</div>
            <div className="comparison-value">{data.nilopolis.total} clientes</div>
          </div>
        </div>
      </div>

      {/* Resumo Rápido */}
      <div className="dashboard-section">
        <h3 className="section-title">⚡ Resumo Rápido</h3>
        <div className="summary-grid">
          <div className="summary-card">
            <div className="summary-icon">🎯</div>
            <div className="summary-content">
              <div className="summary-title">Taxa de Ativação</div>
              <div className="summary-value">
                {((data.geral.ativos / data.geral.total) * 100).toFixed(1)}%
              </div>
              <div className="summary-desc">
                {data.geral.ativos} de {data.geral.total} clientes
              </div>
            </div>
          </div>

          <div className="summary-card">
            <div className="summary-icon">💰</div>
            <div className="summary-content">
              <div className="summary-title">Clientes Pagantes</div>
              <div className="summary-value">
                {data.geral.ativos + data.geral.inadimplentes}
              </div>
              <div className="summary-desc">
                Ativos + Inadimplentes
              </div>
            </div>
          </div>

          <div className="summary-card">
            <div className="summary-icon">📈</div>
            <div className="summary-content">
              <div className="summary-title">Potencial de Ativação</div>
              <div className="summary-value">
                {data.geral.aInstalar}
              </div>
              <div className="summary-desc">
                Clientes a instalar
              </div>
            </div>
          </div>

          <div className="summary-card">
            <div className="summary-icon">⚡</div>
            <div className="summary-content">
              <div className="summary-title">Taxa de Retenção</div>
              <div className="summary-value">
                {(((data.geral.total - data.geral.cancelados) / data.geral.total) * 100).toFixed(1)}%
              </div>
              <div className="summary-desc">
                Clientes não cancelados
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;

